import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GPSTrackService } from './gps-track.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [GPSTrackService],
})
export class GPSTrackModule {}
